'use strict'

window.lstore = window.lstore || {
  setting_status:0,
  hello_status:1,
  menu_status:1,
  feed_status:0,
  weibo_status:0,
  pie_setting:null,
  car_home_feed_lists:''
    
}

export default window.lstore



// WEBPACK FOOTER //
// ./src/store.js